import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Logo from "../../../../assets/images/footer/driverTok.png";
import MenuIcon from "@mui/icons-material/Menu";
import "../../../../scss/common.scss";
import "./auth-header.scss";

const AuthHeader = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [toggle, setToggle] = useState(false);

  
  useEffect(() => {
      setOpen(window.innerWidth > 1151);
      setToggle(window.innerWidth < 1151);
  }, []);


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1151) {
        setOpen(false);
        setToggle(true);
      } else {
        setOpen(true);
        setToggle(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <header>

      <Grid container>
      <Grid item md={12} sx={{display:'flex',justifyContent:'space-between',width:'100%',alignItems:'center',flexWrap:'wrap', py:{xs:"5px", md:"20px"}, px:{xs:'7px',md:'30px'}}}  >
        <Grid item  xs={8} md={1} sx={{p:0,py:{md:0,xs:1}}} onClick={()=> navigate("/authentication/signin")}>
          <img src={Logo} className="logo cursor-pointer" alt="logo" height={40}   />
        </Grid>
        {toggle && (
            <Grid item xs={4} md={3} sx={{paddingRight:'10px'}}>
              <MenuIcon onClick={() => setOpen(!open)} sx={{ float: "right" }} />
            </Grid>
          )}
        {open && (
          <Grid item container xs={12} md={11} sx={{justifyContent:{xs:"center",md:'end'}}}>
            <Grid item container alignItems="center" xs={11} lg={12} className="headerRightItems" sx={{gap:{xs:'0px',md:'18px',xl:'25px'}}}>
              <li>Home</li>
              <li>About Us</li>
              <li>Why Us</li>
              <li>What We Do</li>
              <li>Blog</li>
              <li>Register Your Interest</li>
              <li>Contact Us</li>
              <li>
                <button
                  onClick={() => {
                    navigate("/authentication/signIn");
                  }}
                  className="signInBtn btn-outline">
                  Sign in
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    navigate("/signup-users");
                  }}
                  className="signUpBtn btn-primary">
                  Sign Up
                </button>
              </li>
            </Grid>
          </Grid>
        )}
      </Grid>
      </Grid>


    </header>
  );
};
export default AuthHeader;
